import React from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function MeuTinyEditor({ value, onChange }) {
  // Pega o role_id do usuário logado (garante que não quebre se não houver user)
  const userRole = JSON.parse(localStorage.getItem("user"))?.role_id;

  console.log(userRole);
  // Plugins e toolbar padrões (SEM MathType/ChemType)
  let plugins = [
    "advlist autolink lists link image charmap print preview anchor",
    "searchreplace visualblocks code fullscreen",
    "insertdatetime media table paste help",
  ];
  let toolbar =
    "undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image link";

  // Se for role_id 3, adiciona MathType/ChemType
  if (userRole != 3) {
    plugins.push("tiny_mce_wiris");
    toolbar +=
      " | tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry";
  }

  // Config externo só para role_id 3
  const external_plugins =
    userRole != 3
      ? {
          tiny_mce_wiris: "/plugins/tiny_mce_wiris/plugin.min.js",
        }
      : {};

  return (
    <Editor
      apiKey="h571b097evztwf0lnsgzj39f40qfnln7cx8v5wypkx6yle0m"
      value={value}
      onEditorChange={onChange}
      init={{
        height: 400,
        menubar: true,
        plugins,
        toolbar,
        external_plugins,
        language: "pt_BR",
        media_live_embeds: true,

        extended_valid_elements:
          "iframe[src|frameborder|style|scrolling|class|width|height|name|align|allow|allowfullscreen]",
        valid_children: "+body[iframe]",

        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
      }}
    />
  );
}
